import { parseInsightRef } from './insightRef';
import {
    JournalIcon,
    DuoFileLinesIcon,
    DuoCalendarDayIcon,
    DuoClipboardListCheckIcon,
    IconComponent
} from '../theme/Icons';

// Icon + human label for an evidence ref, by the kind of thing it points at. Note the wording: a
// check-in is a "journal entry" in the UI (never "check-in"), and we stay person-neutral -- a shared
// care insight can cite another member's content, so nothing here says "your".
export const evidenceKindMeta = (ref: string): { label: string; Icon: IconComponent } => {
    const parsed = parseInsightRef(ref);
    if (!parsed) {
        return { label: 'Entry', Icon: DuoFileLinesIcon };
    }

    if (parsed.contentType === 'note') {
        if (parsed.noteKind === 'checkin-personal') {
            return { label: 'Personal journal entry', Icon: JournalIcon };
        }
        if (parsed.noteKind === 'checkin-care') {
            return { label: 'Care journal entry', Icon: JournalIcon };
        }
        return { label: 'Note', Icon: DuoFileLinesIcon };
    }
    if (parsed.contentType === 'appointment') {
        return { label: 'Appointment', Icon: DuoCalendarDayIcon };
    }
    if (parsed.contentType === 'task') {
        return { label: 'Task', Icon: DuoClipboardListCheckIcon };
    }

    return { label: 'Entry', Icon: DuoFileLinesIcon };
};

// A non-openable evidence row explains why. Today the only "cited but not openable" case is another
// member's personal journal entry (author-only server-side); unparseable refs just render inert.
export const evidenceLockedReason = (ref: string): string | undefined => {
    const parsed = parseInsightRef(ref);
    if (parsed?.contentType === 'note' && parsed.noteKind === 'checkin-personal') {
        return 'Personal journal entries are only visible to the person who wrote them.';
    }
    return undefined;
};

// Evidence snippets quote the reflection digest verbatim, and a check-in's digest line can carry a
// trailing structured "Check-in details: feeling/energy" block (raw scale codes on insights generated
// before the digest rendered labels). Those values belong to the check-in itself, which the row opens
// into -- strip them from the excerpt.
export const evidenceDisplaySnippet = (snippet: string): string => {
    return snippet.replace(/\s*Check-?in details:[\s\S]*$/i, '').trim();
};
